import React from "react";
import { List, makeStyles, createStyles } from "@material-ui/core";

/** スタイル定義 */
const useStyles = makeStyles(() =>
  createStyles({
    nav: {
      width: "48px",
    },
  })
);

interface Props {
  children?: React.ReactNode;
}

/** サイドバーナビゲータ */
export function SidebarNav(props: Props) {
  const classes = useStyles();

  const { children } = props;

  //--------------------
  // コンポーネント
  return (
    <List
      component="nav"
      className={classes.nav}
      aria-label="side menu"
      disablePadding
    >
      {children}
    </List>
  );
}
